<template>
  <ToggleSection label="Single-Cell Sample" :collapsed="!dv.isEditing">
    <FieldGrid
      class="form-fields"
      :fields="fieldsGrid"
      :dv="dv"
      :validation-errors="validationErrors"
    />
  </ToggleSection>
</template>

<script>
import { computed } from 'vue'
import ToggleSection from '@/components/fields/ToggleSection.vue'
import FieldGrid from '@/components/fields/FieldGrid.vue'

export default {
  name: 'SingleCellSample',
  components: { ToggleSection, FieldGrid },
  props: {
    dv: { type: Object, required: true },
    validationErrors: { type: Object, default: () => ({}) },
    hiddenFields: { type: Array, default: () => [] },
  },
  setup(props) {
    const fieldsGrid = computed(() => {
      const grid = [['single_cell_type', 'cell_number']]
      const row2 = []
      if (!props.hiddenFields.includes('single_cell_library_construction')) {
        row2.push('single_cell_library_construction')
      }
      if (!props.hiddenFields.includes('single_cell_isolation')) {
        row2.push('single_cell_isolation')
      }
      if (row2.length) grid.push(row2)
      if (!props.hiddenFields.includes('single_cell_well_quality')) {
        grid.push(['single_cell_well_quality'])
      }
      return grid
    })

    return { fieldsGrid }
  },
}
</script>
